import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ProjectsPage from "../pages/projects/page";
import ProjectDetailPage from "../pages/project-detail/page";
import ElectricalPage from "../pages/electrical/page";
import ConstructionPage from "../pages/construction/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/projects",
    element: <ProjectsPage />,
  },
  {
    path: "/projects/:id",
    element: <ProjectDetailPage />,
  },
  {
    path: "/electrical",
    element: <ElectricalPage />,
  },
  {
    path: "/construction",
    element: <ConstructionPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
